import { render, staticRenderFns } from "./bomDetailHead.vue?vue&type=template&id=8fb00550&"
import script from "./bomDetailHead.vue?vue&type=script&lang=js&"
export * from "./bomDetailHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports